import { mapGetters, mapMutations, mapActions } from "vuex";
import { cableSelectionRequiredOfferings, cableSelectionAvailableOptions } from '../settings';
import { snakeCase } from "../utils";
import axios from 'axios';
import AnalyticsMixin from '../../forms/mixins/AnalyticsMixin'
import { analyticsTrack } from '../../bundled_js/analytics_wrapper'
import Recaptcha from './recaptcha'
export const WebstoreResources = {
  mixins: [AnalyticsMixin, Recaptcha],
	data() {
		return {

		}
	},

	computed: {
		...mapGetters([
			'activeProductKey',
			'activeOfferKey',
			'activeProductInfo',
			'activeProductTab',
			'currencySymbol',
      'activeProductFamily',
      'isCableSelectionActive',
      'displayVehicleCableSelectionOptions',
      'bagStep',
      'productCatalog',
      'isAccountCreatedAfterTitan',
      'isAnonymousCustomer',
      'pricingModalComplete',
      'anonymousLargeFleet',
      'isPartnerAccount',
      'isVGBasicCustomer'
		]),

		...mapGetters('content', [
			'webstoreContent',
			'footerContent',
      'contractDisclaimer',
      'webstoreGlobals',
		]),

		...mapGetters("checkout", [
      "checkoutType",
			"displayNACableSelection",
      "currencyIsoCode",
      "smallFleetOpportunity",
			"currencyIsoCode",
      "showContractDisclaimer",
      "isENT",
      'safetyEventReview',
      "hideLicenses",
      'hasContractExpired',
      "safetyEventReviewPrice"
    ]),

		...mapGetters("shoppingCart", [
			"productsInCart"
		]),

    ...mapGetters("webstoreForm", [
      'fleetSize',
      "businessUnit",
      'inquiryModalSubmitted'
    ]),

		onlyOneCableSelectionMethod() {
			return cableSelectionAvailableOptions[this.activeProductKey]
				&& cableSelectionAvailableOptions[this.activeProductKey].length === 1 
		},

		plugTypeOnly() {
			return cableSelectionAvailableOptions[this.activeProductKey]
				&& cableSelectionAvailableOptions[this.activeProductKey].length === 1 
				&& cableSelectionAvailableOptions[this.activeProductKey][0] === 'plug type'
		},

    submitButtonText() {
      return this.existingOfferInCart
        ? this.webstoreContent.selectProductsPage.update_bag
        : this.webstoreContent.addToBag;
    },

    buyButtonLanguage() {
      if (this.shouldCustomerSeePricing && (!this.isENT || ((this.activeOffer.monthlyUnitPrice && this.activeOffer.monthlyUnitPrice !== 0) || this.activeProductKey.includes("CBL")))) {
        return this.webstoreContent.webstoreBody.product_nav.buy;
      } else {
        return this.webstoreContent.webstoreBody.product_nav.inquire
      }
    },
  
    cablesNeededCount() {
      return this.$store.getters[
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`
      ];
    },

		cablesSelectedCount() {
      return this.$store.getters[
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesSelectedCount`
      ];
    },

    currentQuantity() {
      return this.$store.getters[`${this.activeProductKey}/quantity`];
    },

		activeOffer() {
      if (this.activeOfferKey && this.activeOfferKey !== 'Cable') {
        return this.activeProductInfo.offerings[this.activeOfferKey]
      }
      else {
        return this.activeProductInfo.offerings[this.activeProductInfo.defaultOffering]
      }
    },

		salesPriceFormatted() {
      return Number.isInteger(this.activeOffer.salesPrice)
        ? this.activeOffer.salesPrice
        : this.activeOffer.salesPrice.toFixed(2);
    },

		offersToShow() {
      if (['VG-CBL', 'AG-CBL'].includes(this.activeProductKey)) {
        return this.filteredOffers;
      }
      else if(this.activeProductKey.includes("CM") && this.isPartnerAccount){
        delete this.activeProductInfo.offerings["Standalone License + Hardware"]
        delete this.activeProductInfo.offerings["License"]
      }
      return this.activeProductInfo.offerings;
    },

		existingOfferInCart() {
      return this.productsInCart.find((offer) => offer.productKey === this.activeProductKey && offer.offerKey === this.activeOfferKey);
    },

		totalSteps() {
      if (this.doesOfferRequireCable(this.activeOfferKey)) {
        if (cableSelectionAvailableOptions[this.activeProductKey] && cableSelectionAvailableOptions[this.activeProductKey].length === 1) {
          return 4
        } else {
          return 5
        }
      } else {
        return 3
      }
    },

    isSafetyEventReviewActive() {
      return this.activeOffer.productCodes.join("").includes('LIC') && this.isENT && this.safetyEventReview && this.activeProductKey.includes('CM')
    },

    totalCablesSubmittedData() {
      return this.$store.getters[
          `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/totalCablesSubmittedData`
      ];
    },

    totalCablesSubmittedCount() {
      let totalQuantity = 0;
      this.totalCablesSubmittedData && this.totalCablesSubmittedData.forEach(cable => {
          totalQuantity += cable.quantity;
      });
      return totalQuantity;
    },

    totalCompiledData() {
      let totalCompiledDataList = {};
      this.totalCablesSubmittedData.forEach(cable => {
          let accessor = (this.cableSkuToNames && this.cableSkuToNames[cable.cable]) || cable.cable;
          if (cable.type === "vin") {
              totalCompiledDataList[accessor]
              ? (totalCompiledDataList[accessor].qty ++ && totalCompiledDataList[accessor].list.push(cable.originalPayload))
              : totalCompiledDataList[accessor] = { qty: cable.quantity, list: [cable.originalPayload]}
          } else if (cable.type === "mmy") {
              if (cable.originalPayload.make) {
                  let compiledName = `${cable.originalPayload.make} ${cable.originalPayload.model} ${cable.originalPayload.year ? cable.originalPayload.year : ''}`;
                  totalCompiledDataList[accessor]
                  ? ((totalCompiledDataList[accessor].qty = totalCompiledDataList[accessor].qty + cable.quantity) && totalCompiledDataList[accessor].list.push(compiledName))
                  : totalCompiledDataList[accessor] = { qty: cable.quantity, list: [compiledName]}
              } else {
                  let compiledName = `${cable.originalPayload.assetType && (cable.originalPayload.assetType === "trailer" ? "Trailer" : "Powered Equipment")} 
                      ${cable.originalPayload.trailerType ? (cable.originalPayload.trailerType.charAt(0).toUpperCase() + cable.originalPayload.trailerType.slice(1)) : ''}`;
                  totalCompiledDataList[accessor]
                  ? ((totalCompiledDataList[accessor].qty = totalCompiledDataList[accessor].qty + cable.quantity) && totalCompiledDataList[accessor].list.push(compiledName))
                  : totalCompiledDataList[accessor] = { qty: cable.quantity, list: [compiledName]}
              }
          } else {
              totalCompiledDataList[accessor]
              ? (totalCompiledDataList[accessor].qty = totalCompiledDataList[accessor].qty + cable.quantity)
              : totalCompiledDataList[accessor] = { qty: cable.quantity, list: []}
          }
      });
      return totalCompiledDataList;
    },
    shouldCustomerSeePricing(){
      if(this.isVGBasicProduct){
        return false;
      }
      if(!this.isAnonymousCustomer){
        return true;
      }
      return this.isAnonymousCustomer && this.pricingModalComplete && !this.anonymousLargeFleet
    },
    isVGBasicProduct(){
      return this.isVGBasicCustomer && this.activeProductKey === "VG54"
    }
	},

	methods: {

		...mapActions("content", [
			"getWebstoreGlobals"
		]),

    ...mapMutations([
      "setActiveProductTabDefault",
      "setActiveProductFamilyInactive",
      "setActiveProductKeyInactive",
      "setActiveOfferKeyInactive",
      "setShoppingCartToOpened",
			"setActiveOfferKey",
      "setActiveProductKey",
      "setActiveProductFamily",
      "setActiveProductTab",
      "setBagStep",
		]),

		routeToReviewPage() {
      this.$router.push({path: '/review-cart'});
    },

		snakeCase(aString) {
      return snakeCase(aString);
    },

    buyButtonFunctionality() {
      if(this.anonymousLargeFleet){
        this.$emit('clicked', 'inquire-anonymous');
      }
      else if (!this.isVGBasicProduct && (!this.isENT || ((this.activeOffer.monthlyUnitPrice && this.activeOffer.monthlyUnitPrice !== 0) || this.activeProductKey.includes("CBL")))) {
        this.$emit('clicked', 'buy');
      }
      else {
        this.$emit('clicked', 'inquire');
      }
    },

    async confirmCables() {
      let vinDone = true
      if (this.$refs['cable-selection'] && this.$refs['cable-selection'].$refs['vin'] && this.$refs['cable-selection'].$refs['vin'].length !== 0) {
        vinDone = await this.$refs['cable-selection'].$refs['vin'][0].submitVinData();
      }
      if (vinDone && this.$refs['cable-selection'] && this.$refs['cable-selection'].$refs['mmy'] && this.$refs['cable-selection'].$refs['mmy'].length !== 0) {
        this.$refs['cable-selection'].$refs['mmy'][0].submitMMYDataHandler();
      }
    },

		setInitialOfferQuantity(offer) {
			let offerInCart = this.isOfferInCart(offer);
			return offerInCart ? offerInCart.quantity : 1;
		},

		setCablesNeededCount(quantity) {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCablesNeededCount`,
        quantity
      );
    },

		setCablesSelectedCount() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCablesSelectedCount`
      );
    },

		setTotalCablesSubmittedData() {
      return this.$store.commit(
        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setTotalCablesSubmittedData`
      );
    },

    calculateTotalPrice(prices) {
      return typeof(prices) !== 'number' ? prices ? prices.reduce((prev, next) => prev += next.price, 0): 'N/A' : prices;
    },

		setCableSelectionMessage(message) {
			return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCableSelectionMessage`, message);
		},

		findExistingOfferInCart(productKey, offerKey) {
      return this.productsInCart.find((offer) => offer.productKey === productKey && offer.offerKey === offerKey);
    },

		isOfferInCart(offer) {
      return this.productsInCart.find((offerInCart) => offerInCart.productKey === offer.productKey && offerInCart.offerKey === offer.offerKey);
    },

		cleanOfferKey(offerKey) {
			return offerKey.replace(/\s|\+|/g, "");
    },

		doesOfferRequireCable(offerKey) {
      return this.activeProductKey in cableSelectionRequiredOfferings
        ? cableSelectionRequiredOfferings[this.activeProductKey].includes(offerKey)
        : false;
    },

		backToWebstoreHome() {
			this.setActiveProductFamilyInactive();
			this.setActiveProductKeyInactive();
			this.setActiveOfferKeyInactive();
			this.setActiveProductTabDefault();
			this.setBagStep(0);
    },

		productAddedToCart() {
			this.setActiveProductFamilyInactive();
			this.setActiveProductKeyInactive();
			this.setActiveOfferKeyInactive();
			this.setActiveProductTabDefault();
			this.setShoppingCartToOpened();
			this.setBagStep(0);
    },

		setTab(label) {
      if (label === 'inquire') {
        this.inquireModalIsOpen = true;
      } else if(label === 'inquire-anonymous'){
        this.inquireAnonymousModalIsOpen = true;
      } 
      else {
        this.setActiveProductTab(label);
        if (label === "buy") {
          this.setBagStep(0);
        }
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    },

		updateBagStep(value) {
      this.setBagStep(value);
    },

    async submitAnonymousLargeFleetLead(data) {
      try {
        let values = {}
        values.email = data.anonymousEmail
        const name = data.anonymousName?.split(' ')
        if (name){
          values.firstname = name[0]
          values.lastname = name[1]
        }
        values.company = data.companyName
        values.phone = data.anonymousPhone

        values.industry = data.industryName.toString()
        
        let ipData = await this.getIPData()
        if(ipData){
          values['ip_data'] = JSON.stringify(ipData)
          values['country'] = ipData['country_name']
        }
        values['businessunit'] = this.businessUnit.toString()
        values['assetcount'] = this.fleetSize

        let recaptchaToken = await this.recaptcha()
        axios.post('/webstore/submit-lead',
        {'lead': values, 'recaptchaToken': recaptchaToken, 'samsaraShipValue': data.samsaraShipValue}
        );

        } catch(e) {
           console.log(e)
        }
        
    }, 
    anonymousLeadSubmissionTracking(source){
        if(!this.inquiryModalSubmitted){
          analyticsTrack(`Anonymous Browsing- submitting large fleet lead from ${source} `,{"url": window.location.pathname})
        }
    }

	}
}